import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {post} from 'bukku/shared/ApiService';

// Read lists
export function* readContactAddressRequest() {
    yield takeEvery(actions.CONTACT_ADDRESSES_READ_REQUEST, function* ({ contactId }, context) {
        try {
            // Prepare request data
            const requestData = {
                lists: ['contact_addresses'],
                params: { contact_addresses: { contact_id: contactId } },
            };

            // Request
            let responseData = {};
            if (requestData.lists.length) {
                const response = yield call(post, '/v2/lists', requestData, context);
                responseData = yield response.data.contact_addresses;
            }

            yield put({
                type: actions.CONTACT_ADDRESSES_READ_SUCCESS,
                responseData,
            });
        }
        catch (error) {
            yield put({
                type: actions.CONTACT_ADDRESSES_READ_ERROR,
                error,
            });
        }
    });
}
export function* readContactAddressSuccess() {
    yield takeEvery(actions.CONTACT_ADDRESSES_READ_SUCCESS, () => {});
}
export function* readContactAddressFailure() {
    yield takeEvery(actions.CONTACT_ADDRESSES_READ_ERROR, () => {});
}

export default function* rootSaga() {
    yield all([
        fork(readContactAddressRequest),
        fork(readContactAddressSuccess),
        fork(readContactAddressFailure),
    ]);
}
